import HeadCom from "@/components/Header.vue";
import FooterCom from "@/components/Footer.vue";
import { getCourseList, getExam, getExamByPost } from "../../api/service.js"

let that;
export default {
  components: {
    HeadCom,
    FooterCom
  },
  data() {
    return {
      contentHeight: { height: '' },
      activeNames: '',
      radio: [],
      examObj: {},
      oldExamObj: {},
      examDetail: {},
      answerSheetList: [],
      checkedCities: [],
      keepTime: "",
      int: {},
      userAnswerList: [],
      totalNum: 0,
      hour: 0, minute: 0, second: 0, millisecond: 0,
      isJx: false,
      loading: true
    }
  },
  created() {
    that = this;
    that.contentHeight.height = window.innerHeight - 400 + 'px';
    that.examObj = JSON.parse(sessionStorage.getItem("examObj"));
    if (that.$route.query.exerciseId != undefined && that.$route.query.exerciseId != "") {

    } else {
      that.loading = false;
      var totalPoints = 0;
      var totalScore = 0;
      var totalNum = 0;//总题数
      var isRightTotalNum = 0;//答对题数
      that.examObj.paperEntity.paperAreaList.forEach((obj) => {
        obj.questionList.forEach((questionObj) => {
          if (questionObj.isRight) {
            totalPoints = totalPoints + questionObj.score;
            isRightTotalNum = isRightTotalNum + 1;
          }
          totalNum = totalNum + 1;
          totalScore = totalScore + questionObj.score;
        });
      });
      that.examObj.totalPoints = totalPoints;
      that.examObj.totalScore = totalScore;
      that.examObj.totalNum = totalNum;
      that.examObj.isRightTotalNum = isRightTotalNum;
    }
    that.getDetail();
  },
  mounted() {
    // var publicCourse = document.getElementsByClassName("practiceResultDetail")
    // publicCourse.style.minHeight = document.body.scrollHeight - 90 - 257 + "px"
  },
  methods: {
    getDetail() {

      that.answerSheetList = [];
      var number = 0;
      that.radio = [];
      if (that.$route.query.exerciseId != undefined && that.$route.query.exerciseId != "") {
          let url = "/exercise/exerciseRecordResult";
        let data = { exerciseRecordId: this.$route.query.exerciseId };
        getExam(url, data).then(res => {
          that.loading = false;
          if (res.success) {
            var totalScore = 0;
            var totalNum = 0;//总题数
            var isRightTotalNum = 0;//答对题数

            that.examObj = res.data;
            that.examObj.paperEntity.paperAreaList.forEach((obj) => {
              obj.questionList.forEach((questionObj) => {
                if (questionObj.isRight) {
                  isRightTotalNum = isRightTotalNum + 1;
                }
                totalNum = totalNum + 1;
                totalScore = totalScore + questionObj.score;

                number = number + 1;
                questionObj.number = number;
                var answerN = "";
                questionObj.questionAnswers.forEach((answersObj, index) => {
                  switch (index) {
                    case 0:
                      answersObj.nName = "A";
                      break;
                    case 1:
                      answersObj.nName = "B";
                      break;
                    case 2:
                      answersObj.nName = "C";
                      break;
                    case 3:
                      answersObj.nName = "D";
                      break;
                    case 4:
                      answersObj.nName = "E";
                      break;
                    case 5:
                      answersObj.nName = "F";
                      break;
                    case 6:
                      answersObj.nName = "G";
                      break;
                  }
                  if (answersObj.isRight) {
                    if (answerN != "") {
                      answerN = answerN + "," + answersObj.nName
                    } else {
                      answerN = answerN + answersObj.nName
                    }
                  }
                });
                questionObj.rightAnswerName = answerN;
              });
              that.answerSheetList.push({ titleName: obj.paperAreaName, list: obj.questionList })
            });
            that.examObj.totalScore = totalScore;
            that.examObj.totalNum = totalNum;
            that.examObj.isRightTotalNum = isRightTotalNum;
            that.examDetail = that.examObj.paperEntity.paperAreaList[0].questionList[0];
            that.totalNum = that.answerSheetList[that.answerSheetList.length - 1].list[that.answerSheetList[that.answerSheetList.length - 1].list.length - 1].number
            that.start();

            that.radio.push(parseInt(that.examDetail.answerId));
          } else {
            that.$message.error(res.message)
          }
        })
      } else {
        that.examObj.paperEntity.paperAreaList.forEach((obj) => {
          obj.questionList.forEach((questionObj) => {
            number = number + 1;
            questionObj.number = number;
            questionObj.questionAnswers.forEach((answersObj, index) => {
              switch (index) {
                case 0:
                  answersObj.nName = "A";
                  break;
                case 1:
                  answersObj.nName = "B";
                  break;
                case 2:
                  answersObj.nName = "C";
                  break;
                case 3:
                  answersObj.nName = "D";
                  break;
                case 4:
                  answersObj.nName = "E";
                  break;
                case 5:
                  answersObj.nName = "F";
                  break;
                case 6:
                  answersObj.nName = "G";
                  break;
              }
            });
          });
          that.answerSheetList.push({ titleName: obj.paperAreaName, list: obj.questionList })
        });
        that.examDetail = that.examObj.paperEntity.paperAreaList[0].questionList[0];
        that.totalNum = that.answerSheetList[that.answerSheetList.length - 1].list[that.answerSheetList[that.answerSheetList.length - 1].list.length - 1].number
        that.start();
        that.radio.push(parseInt(that.examDetail.answerId));
      }
    },
    clickAnswerSheet(detail) {//点击答题卡
      that.examDetail = detail;
      that.checkedCities = [];
      that.radio = [];
      var list = [];
      if (that.examDetail.questionType == "多选题") {
        if (that.examDetail.answerId != undefined) {
          list = that.examDetail.answerId.split(",");
          list.forEach(function (k) {
            if (k !== "") {
              that.checkedCities.push(parseInt(k));
            }
          })
        }

      } else {
        that.radio.push(parseInt(detail.answerId));
      }
      if (detail.answerId != undefined) {
        that.examDetail.isDisabled = true;
      }
    },
    onTopic() {//上一题
      that.checkedCities = [];
      that.radio = [];
      for (var c = 0; c < that.answerSheetList.length; c++) {
        for (var i = 0; i < that.answerSheetList[c].list.length; i++) {
          if (that.answerSheetList[c].list[i].id == that.examDetail.id) {
            if (i != 0) {
              that.examDetail = that.answerSheetList[c].list[i - 1];
            } else {
              that.examDetail = that.answerSheetList[c - 1].list[that.answerSheetList[c - 1].list.length - 1];
            }
          }
        }
      }
      if (that.examDetail.questionType == "多选题") {
        if (that.examDetail.answerId != undefined) {
          var list = that.examDetail.answerId.split(",");
          list.forEach(function (k) {
            if (k !== "") {
              that.checkedCities.push(parseInt(k));
            }
          })
        }
      }else {
        that.radio.push(parseInt(that.examDetail.answerId));
      }
      if (that.examDetail.answerId != undefined) {
        that.examDetail.isDisabled = true;
      }
    },
    nextQuestion() {//下一题
      that.checkedCities = [];
      var detail = {};
      that.radio = [];
      for (var c = 0; c < that.answerSheetList.length; c++) {
        for (var i = 0; i < that.answerSheetList[c].list.length; i++) {
          if (that.answerSheetList[c].list[i].id == that.examDetail.id) {
            if (i >= that.answerSheetList[c].list.length - 1) {
              detail = that.answerSheetList[c + 1].list[0];
            } else {
              detail = that.answerSheetList[c].list[i + 1];
            }
          }
        }
      }
      that.examDetail = detail;
      if (that.examDetail.questionType == "多选题") {
        if (that.examDetail.answerId != undefined) {
          var list = that.examDetail.answerId.split(",");
          list.forEach(function (k) {
            if (k !== "") {
              that.checkedCities.push(parseInt(k));
            }
          })
        }
      } else {
        that.radio.push(parseInt(detail.answerId));
      }
      if (that.examDetail.answerId != undefined) {
        that.examDetail.isDisabled = true;
      }
    },

    timer() {
      that.millisecond = that.millisecond + 50;
      if (that.millisecond >= 1000) {
        that.millisecond = 0;
        that.second = that.second + 1;
      }
      if (that.second >= 60) {
        that.second = 0;
        that.minute = that.minute + 1;
      }

      if (that.minute >= 60) {
        that.minute = 0;
        that.hour = that.hour + 1;
      }
      var hourObj = that.hour > 9 ? that.hour : "0" + that.hour;
      var minuteObj = that.minute > 9 ? that.minute : "0" + that.minute;
      var secondObj = that.second > 9 ? that.second : "0" + that.second;
      that.keepTime = hourObj + ':' + minuteObj + ':' + secondObj;
    },
    //开始函数
    start() {
      that.hour = 0;
      that.minute = 0;
      that.second = 0;//初始化
      that.int = setInterval(that.timer, 50);//每隔50毫秒执行一次timer函数
    },
    stop() {
      window.clearInterval(that.int);
    },
    //返回上一页
    goBack() {
      if (this.$route.query.exerciseId != undefined) {
        this.$router.push({
          path: "/examRecord"
        });
      } else {
        this.$router.push({
          path: "/examList"
        });
      }

    }
  }
}
